import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export const SortComponent = (props) => {
  return (
    <div>
      <div
        className="f10-400"
        align="center"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={props.handleClick}
      >
        <img
          src={require("../../../assets/images/iconButton/sortbtn.svg")}
          width={props.sortImgWidth ? "70px" : "80px"}
        />
        <br />
        {/* Sort */}
      </div>
      <Menu
        id="simple-menu"
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleClose}
      >
        <MenuItem onClick={props.selectClick} disabled>
          {props?.displayOnlineOffers === "ONLINE_OFFERS"
            ? "Offer Name"
            : props?.displayOnlineOffers === "NOMINATION"
            ? "Restaurant Name"
            : "Restaurant Name / User Name"}
        </MenuItem>
        <MenuItem onClick={props.selectClick("A-Z")}>A-Z</MenuItem>
        <MenuItem onClick={props.selectClick("Z-A")}>Z-A</MenuItem>
        {props?.displayOnlineOffers === "ONLINE_OFFERS" ||
        props?.displayOnlineOffers === "NOMINATION" ? null : (
          <MenuItem onClick={props.selectClick} disabled>
            Restaurant Status
          </MenuItem>
        )}
        {props?.displayOnlineOffers === "ONLINE_OFFERS" ||
        props?.displayOnlineOffers === "NOMINATION" ? null : (
          <MenuItem onClick={() => props.statusSortHandle(1)}>
            &#128308; &#128993; &#128994; &#9711;
          </MenuItem>
        )}
        {props?.displayOnlineOffers === "ONLINE_OFFERS" ||
        props?.displayOnlineOffers === "NOMINATION" ? null : (
          <MenuItem onClick={() => props.statusSortHandle(2)}>
            &#9711; &#128994; &#128993; &#128308;{" "}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
